import {Injectable} from "@angular/core";
import {HttpRepository} from "./http.repository";
import {UserSessionRepository} from "./user-session.repository";
import {Observable} from "rxjs";
import {ScreenConfig} from "../interfaces/rest/ScreenConfig";
import {GlobalConfig} from "../configs/GlobalConfig";

@Injectable()
export class ScreenConfigRepository {

  constructor(private httpRepository: HttpRepository,
              private userSessionRepository: UserSessionRepository) {
  }

  getScreenConfig(screenName: string): Observable<ScreenConfig> {
    const userId = this.userSessionRepository.getUserSession()!.userId!;
    return this.httpRepository.get(`${GlobalConfig.endpoints.users}/${userId}/screenconfigs/${screenName}`);
  }

  saveScreenConfig(screenName: string, screenConfig: ScreenConfig): Observable<ScreenConfig> {
    const userId = this.userSessionRepository.getUserSession()!.userId!;
    return this.httpRepository.post(`${GlobalConfig.endpoints.users}/${userId}/screenconfigs/${screenName}`, screenConfig);
  }
}
